import { useLocation, useNavigate } from "react-router-dom";

/**
 * Back navigation that never dead-ends. The embed iframe restarts with a
 * fresh history, so `navigate(-1)` does nothing on the first screen shown.
 * Without a previous entry, `goBack` goes to `fallbackPath` instead.
 */
export function useSafeBack(fallbackPath: string) {
  const navigate = useNavigate();
  const { key } = useLocation();
  const hasPreviousEntry = key !== "default";

  const goBack = () => {
    if (hasPreviousEntry) navigate(-1);
    else navigate(fallbackPath, { replace: true });
  };

  return { goBack, hasPreviousEntry };
}
